export const TokenExpirancyKey = "default_auth_token_expirancy";
export const TokenKey = "default_auth_token";
